import React, { useState } from "react";
import { Container, Grid, Typography, Box, Paper, Tabs, Tab } from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import AddPartition from "./AddPartition";
import PartitionList from "./PartitionList";
import AddBuilding from "./AddBuilding";
import BuildingList from "./BuildingList";

const PartitionsIndex = () => {
  const [refreshKey, setRefreshKey] = useState(0);
  const [tabValue, setTabValue] = useState(0);

  const handleRefresh = () => {
    setRefreshKey((prev) => prev + 1);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box py={3}>
        <Container maxWidth="xl">
          <Box mb={4}>
            <Typography variant="h3" fontWeight="bold" color="dark">
              Resources Management
            </Typography>
            <Typography variant="button" color="text" fontWeight="regular">
              Manage clinic locations (Partitions) and Buildings to control patient flow capacity.
            </Typography>
          </Box>

          <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
            <Tabs value={tabValue} onChange={handleTabChange} aria-label="resource management tabs">
              <Tab label="Partitions" />
              <Tab label="Buildings" />
            </Tabs>
          </Box>

          {tabValue === 0 && (
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <AddPartition onSuccess={handleRefresh} />
              </Grid>

              <Grid item xs={12}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 3,
                    borderRadius: "15px",
                    border: "1px solid #e0e0e0",
                    backgroundColor: "#fff",
                  }}
                >
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={1}
                  >
                    <Typography variant="h5" fontWeight="bold">
                      Partitions Registry
                    </Typography>
                  </Box>

                  <PartitionList refreshKey={refreshKey} />
                </Paper>
              </Grid>
            </Grid>
          )}

          {tabValue === 1 && (
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <AddBuilding onSuccess={handleRefresh} />
              </Grid>

              <Grid item xs={12}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 3,
                    borderRadius: "15px",
                    border: "1px solid #e0e0e0",
                    backgroundColor: "#fff",
                  }}
                >
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={1}
                  >
                    <Typography variant="h5" fontWeight="bold">
                      Buildings Registry
                    </Typography>
                  </Box>

                  <BuildingList refreshKey={refreshKey} />
                </Paper>
              </Grid>
            </Grid>
          )}
        </Container>
      </Box>
    </DashboardLayout>
  );
};

export default PartitionsIndex;
